import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import { UccelliniLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand({ collapsed, compact = false }) {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align='center' direction='column'>
      {!collapsed && (
        <>
          {compact ? (
            <UccelliniLogo
              variant="compact"
              h={{ base: '20px', md: '24px', lg: '26px' }}
              maxW={{ base: '140px', md: '160px', lg: '175px' }}
              my={{ base: '12px', md: '16px', lg: '20px' }}
            />
          ) : (
            <UccelliniLogo h='26px' w='175px' my='32px' color={logoColor} />
          )}
          <HSeparator mb={compact ? '12px' : '20px'} />
        </>
      )}
    </Flex>
  );
}

export default SidebarBrand;
